import { useLinkSigner } from '../../store/link/hooks'
import { useDispatch } from 'react-redux'
import { useAccountInfo } from '../../store/account/hooks'
import { useCallback } from 'react'
import { Address, TokenId, TokenSymbol } from '../../types'
import { BigNumber } from 'ethers'
import { updateWithdrawing } from '../../store/withdraw/actions'
import { getAccountNonce } from '../../api/v1/account'
import { signTransfer } from '../../utils/signer/transactions/transfer'
import { SUB_ACCOUNT_ID } from '../../config'
import { postTransfer, PostTransferBody } from '../../api/v1/transfer'
import { w2e } from '../../utils/number'
import toastify from '../../components/Toastify'
import i18n from '../../i18n'
import { updateModal } from '../../store/app/actions/modalActions'
import { zklinkExplorerUrl } from 'utils/explorer'
import { UserRejectedError } from '../../utils/errors/userReject'

export function useTransfer() {
  const signer = useLinkSigner()
  const dispatch = useDispatch()
  const accountInfo = useAccountInfo()
  return useCallback(
    async function transfer({
      address,
      tokenId,
      tokenSymbol,
      amount,
      fee,
    }: {
      address: Address
      tokenId: TokenId
      tokenSymbol: TokenSymbol
      amount: BigNumber
      fee: BigNumber
    }) {
      try {
        if (!signer) {
          return
        }
        dispatch(updateWithdrawing(true))
        const { nonce } = await getAccountNonce(2).then((r) => r.data)

        const { layer2Id = 0 } = accountInfo

        const signedData = await signTransfer(signer, {
          accountId: layer2Id,
          to: address,
          fromSubAccountId: SUB_ACCOUNT_ID,
          toSubAccountId: SUB_ACCOUNT_ID,
          tokenId: tokenId,
          tokenSymbol: tokenSymbol,
          amount: amount.toString(),
          fee: fee.toString(),
          nonce: nonce,
        })

        const { tx, layer1_signature } = signedData

        const body: PostTransferBody = {
          currency: tokenSymbol.toUpperCase(), // 'BTC'
          to: tx.to, // '0x00...0000'
          fee: w2e(tx.fee), // '0.001'
          amount: w2e(tx.amount), // '100.1'
          nonce: tx.nonce, // 0
          ts: tx.ts, // 1684419923
          signature: tx.signature.signature,
          ethSignature: layer1_signature,
        }
        const rpcResponse = await postTransfer(0, body)

        toastify.transaction(
          i18n.t('common-withdraw-submitted'),
          zklinkExplorerUrl(rpcResponse.data.txHash),
        )

        dispatch(updateModal({ modal: 'withdraw', open: false }))
      } catch (e) {
        if (UserRejectedError.is(e)) {
        } else {
          console.error(e)
          toastify.error(e.message)
        }
      } finally {
        dispatch(updateWithdrawing(true))
      }
    },
    [signer, accountInfo],
  )
}
